import type { FC } from 'react';
import React from 'react';
import { Box, Typography } from '@mui/material';

import type { SentimentCode } from 'src/types/dashboard';
import { getRelativeValue } from 'src/components/dashboard/DashboardPage/helper';

import { styles } from './index.styles';

interface SentimentBarSectionProps {
  count: number;
  highestCount: number;
  isRootLevel: boolean;
  handleClick: (
    topicSentimentId: null | string,
    sentiment?: SentimentCode,
  ) => void;
  id: string | null;
  color: string;
  sentiment: SentimentCode;
}

const SentimentBarSection: FC<SentimentBarSectionProps> = ({
  count,
  highestCount,
  isRootLevel,
  handleClick,
  id,
  color,
  sentiment,
}) => {
  // Calculate the percentage length of each bar using the highestCount.
  const barWidth = getRelativeValue(count, highestCount, 0);
  return (
    <Box
      sx={styles.stackElement(count, highestCount, isRootLevel, color)}
      onClick={() => handleClick(id, sentiment)}
    >
      {barWidth > 5 && (
        <Typography color="white" sx={{ px: 0.5 }}>
          {count}
        </Typography>
      )}
    </Box>
  );
};

export default SentimentBarSection;
